import React, { FC } from "react";

import GlobalLayout from "./GlobalLayout";

import { useFetchUser } from "@hooks/useFetchUser";
import { GlobalLoader } from "@components/common";
import { useBootIntercom } from "@hooks/useBootIntercom";

const GlobalLayoutContainer: FC = () => {
  const { isFetched } = useFetchUser();

  useBootIntercom();

  if (!isFetched) {
    return <GlobalLoader size={100} />;
  }

  return <GlobalLayout />;
};

export default GlobalLayoutContainer;
